<template>
  <timeline
    :timeline="timeline"
    :loading="loading"
    :config="{log: {slim: true}}"
    :read-only="true"
    :tiles="['log']"
    manual
    anchor="dialog-menubar"
    @search="(val) => filter = (val || '')"
  />

  <q-toolbar class="sticky-position from-page-bottom blurred-container">
    <q-space />
    <q-pagination
      v-if="max > 1"
      v-model="page"
      input
      boundary-links
      boundary-numbers
      :max-pages="3"
      :max="max"
    />
    <q-space />
  </q-toolbar>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      loading: false,
      timeline: [],
      filter: '',
      page: 1,
      max: 1
    }
  },
  watch: {
    page () {
      this.getLogs()
    },
    filter () {
      if (this.page !== 1) {
        this.page = 1
      }
      else {
        this.getLogs()
      }
    }
  },
  methods: {
    async getLogs () {
      this.loading = true
      const { status, payload } = await this.$get('v1/business/company/users/logs', {
        user_id: this.id,
        page: this.page,
        search: this.filter
      })
      this.loading = false
      if (status === 'success') {
        this.timeline = payload.timeline
        this.max = payload.max
      }
    }
  },
  mounted () {
    this.getLogs()
  }
}
</script>
